<ngx-datatable
  class="ion-hide-sm-down"
  (activate)="goToOrder($event)"
  columnMode="force"
  [footerHeight]="50"
  [headerHeight]="50"
  [messages]="{ emptyMessage: loadFailed ? 'Could not load orders. Please retry.' : 'No orders for this customer.' }"
  ngClass="bootstrap"
  [reorderable]="true"
  [rowHeight]="50"
  [rows]="page.data"
  [scrollbarH]="true"
  [scrollbarV]="false"
  (tableContextmenu)="onTableContextMenu.emit($event)"
  [externalPaging]="true"
  [externalSorting]="true"
  [count]="page.pageInfo.count"
  [offset]="page.pageInfo.offset"
  [limit]="page.pageInfo.pageSize"
  (page)="setPage($event)"
  (sort)="setSort($event)">
  >
  @if (columnConfig.createdAt.visible) {
    <ngx-datatable-column
      [sortable]="columnConfig.createdAt.sortable && !forcedSortBy"
      name="Created"
      prop="createdAt"
      [cellClass]="getCellClass">
      <ng-template let-row="row" ngx-datatable-cell-template>
        @if (tryParseDate(row.createdAt); as d) {
          <ion-text class="date-text">{{ d | date: "mediumDate" }}</ion-text>
          <br />
          <ion-text class="time-text">{{ d | date: "shortTime" }}</ion-text>
        } @else {
          <ion-text class="date-text">-</ion-text>
        }
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnConfig.customerFullName.visible) {
    <ngx-datatable-column
      [sortable]="false"
      name="Customer"
      prop="customerFullName"
      [cellClass]="getCellClass">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text innerHTML="{{ row.customerFullName | highlightsearch: searchString }}"></ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnConfig.formattedAddress.visible) {
    <ngx-datatable-column
      [sortable]="false"
      name="Address"
      prop="formattedAddress"
      [cellClass]="getCellClass">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text innerHTML="{{ row.formattedAddress | highlightsearch: searchString }}"></ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnConfig.earliestFulfillment.visible) {
    <ngx-datatable-column
      [sortable]="columnConfig.earliestFulfillment.sortable && !forcedSortBy"
      name="Fulfillment"
      prop="earliestFulfillment"
      [cellClass]="getCellClass">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text class="date-text">{{ row.earliestFulfillment | date }}</ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnConfig.base.visible) {
    <ngx-datatable-column
      [sortable]="false"
      name="Target Base"
      prop="baseLocation"
      [cellClass]="getCellClass">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text innerHTML="{{ camelCaseToDisplayString(row.baseLocation) | highlightsearch: searchString }}"></ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnConfig.firestoreSubscriptionType.visible) {
    <ngx-datatable-column
      [sortable]="false"
      name="Subscription"
      prop="subscription">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text>{{ row.firestoreSubscriptionType }}</ion-text>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnConfig.status.visible) {
    <ngx-datatable-column
      [sortable]="columnConfig.status.sortable && !forcedSortBy"
      name="Status"
      prop="status"
      [cellClass]="getCellClass">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <rc-order-status-badge [orderStatus]="row.status"></rc-order-status-badge>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnConfig.service.visible) {
    <ngx-datatable-column
      [sortable]="columnConfig.service.sortable && !forcedSortBy"
      name="Service Type"
      prop="serviceType"
      [cellClass]="getCellClass">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <rc-service-type-badge [serviceType]="row.serviceType"></rc-service-type-badge>
      </ng-template>
    </ngx-datatable-column>
  }

  @if (columnConfig.driverFullName.visible) {
    <ngx-datatable-column
      [sortable]="false"
      name="Driver"
      prop="driverFullName"
      [cellClass]="getCellClass">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <ion-text innerHTML="{{ row.driverFullName | highlightsearch: searchString }}"></ion-text>
      </ng-template>
    </ngx-datatable-column>
  }
</ngx-datatable>

<rc-mobile-order-table
  class="ion-hide-sm-up"
  [orders]="page.data"
[searchString]="searchString"></rc-mobile-order-table>
